package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.FlagHr: ImageVector
    get() {
        if (_flagHr != null) {
            return _flagHr!!
        }
        _flagHr = Builder(name = "FlagHr", defaultWidth = 609.5.dp, defaultHeight = 610.5.dp,
                viewportWidth = 609.5f, viewportHeight = 610.5f).apply {
            group {
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 1.0f)
                    lineTo(0.0f, 228.287f)
                    lineTo(609.453f, 228.287f)
                    lineTo(609.453f, 1.0f)
                    quadTo(84.235f, 1.265f, 0.0f, 1.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 401.199f)
                    lineTo(609.453f, 401.199f)
                    lineTo(609.453f, 227.289f)
                    lineTo(0.0f, 227.289f)
                    lineTo(0.0f, 401.199f)
                    lineTo(0.0f, 401.199f)
                    lineTo(0.0f, 401.199f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF2C328C)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 610.484f)
                    lineTo(609.453f, 609.456f)
                    lineTo(609.453f, 401.199f)
                    lineTo(0.0f, 401.199f)
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(298.9f, 449.185f)
                    lineTo(298.9f, 449.185f)
                    curveTo(354.685f, 449.185f, 400.321f, 403.545f, 400.321f, 347.765f)
                    lineTo(400.321f, 227.248f)
                    lineTo(197.478f, 227.248f)
                    lineTo(197.478f, 347.765f)
                    curveTo(197.478f, 403.547f, 243.118f, 449.185f, 298.897f, 449.185f)
                    lineTo(298.9f, 449.185f)
                    lineTo(298.9f, 449.185f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(298.9f, 447.56f)
                    lineTo(298.9f, 447.56f)
                    curveTo(353.62f, 447.56f, 398.386f, 402.792f, 398.386f, 348.075f)
                    lineTo(398.386f, 229.201f)
                    lineTo(199.412f, 229.201f)
                    lineTo(199.412f, 348.075f)
                    curveTo(199.412f, 402.793f, 244.181f, 447.56f, 298.9f, 447.56f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(397.053f, 227.256f)
                    lineTo(421.369f, 172.137f)
                    lineTo(402.676f, 141.948f)
                    lineTo(372.606f, 153.08f)
                    lineTo(351.496f, 128.949f)
                    lineTo(323.676f, 144.893f)
                    lineTo(298.87f, 124.576f)
                    lineTo(274.064f, 144.893f)
                    lineTo(246.245f, 128.949f)
                    lineTo(225.132f, 153.08f)
                    lineTo(195.064f, 141.948f)
                    lineTo(176.365f, 172.143f)
                    lineTo(200.65f, 227.275f)
                    curveTo(230.61f, 213.581f, 263.877f, 205.937f, 298.873f, 205.937f)
                    curveTo(333.852f, 205.937f, 367.104f, 213.575f, 397.056f, 227.256f)
                    lineTo(397.053f, 227.256f)
                    lineTo(397.053f, 227.256f)
                    lineTo(397.053f, 227.256f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(396.661f, 226.015f)
                    lineTo(420.401f, 172.203f)
                    lineTo(402.314f, 142.997f)
                    lineTo(372.35f, 154.091f)
                    lineTo(351.313f, 130.041f)
                    lineTo(323.59f, 145.928f)
                    lineTo(298.873f, 125.684f)
                    lineTo(274.154f, 145.928f)
                    lineTo(246.432f, 130.041f)
                    lineTo(225.392f, 154.088f)
                    lineTo(195.428f, 142.995f)
                    lineTo(177.336f, 172.208f)
                    lineTo(201.045f, 226.029f)
                    curveTo(230.92f, 212.508f, 264.044f, 204.975f, 298.874f, 204.975f)
                    curveTo(333.69f, 204.975f, 366.8f, 212.503f, 396.666f, 226.015f)
                    lineTo(396.661f, 226.015f)
                    lineTo(396.661f, 226.015f)
                    lineTo(396.661f, 226.015f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF4691D4)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(395.536f, 223.457f)
                    lineTo(418.078f, 172.364f)
                    lineTo(401.449f, 145.516f)
                    lineTo(371.796f, 156.496f)
                    lineTo(358.07f, 210.495f)
                    curveTo(371.005f, 213.793f, 383.524f, 218.152f, 395.533f, 223.46f)
                    lineTo(395.536f, 223.457f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF2C328C)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(274.412f, 148.383f)
                    lineTo(274.36f, 148.424f)
                    lineTo(246.869f, 132.672f)
                    lineTo(226.053f, 156.465f)
                    lineTo(239.757f, 210.471f)
                    curveTo(252.474f, 207.233f, 265.593f, 205.024f, 279.014f, 203.913f)
                    lineTo(274.409f, 148.383f)
                    lineTo(274.412f, 148.383f)
                    lineTo(274.412f, 148.383f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF2C328C)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(371.8f, 156.492f)
                    lineTo(371.733f, 156.517f)
                    lineTo(350.872f, 132.672f)
                    lineTo(323.441f, 148.392f)
                    lineTo(318.816f, 203.924f)
                    curveTo(332.238f, 205.036f, 345.354f, 207.253f, 358.07f, 210.495f)
                    lineTo(371.796f, 156.496f)
                    lineTo(371.8f, 156.492f)
                    lineTo(371.8f, 156.492f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF4691D4)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(226.053f, 156.465f)
                    lineTo(226.008f, 156.517f)
                    lineTo(196.293f, 145.513f)
                    lineTo(179.665f, 172.361f)
                    lineTo(186.034f, 186.845f)
                    lineTo(202.17f, 223.475f)
                    curveTo(214.218f, 218.149f, 226.781f, 213.78f, 239.76f, 210.473f)
                    lineTo(226.054f, 156.468f)
                    lineTo(226.053f, 156.465f)
                    lineTo(226.053f, 156.465f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(298.818f, 443.501f)
                    lineTo(298.818f, 443.501f)
                    curveTo(351.453f, 443.501f, 394.518f, 400.436f, 394.518f, 347.799f)
                    lineTo(394.518f, 232.94f)
                    lineTo(203.118f, 232.94f)
                    lineTo(203.118f, 347.799f)
                    curveTo(203.118f, 400.436f, 246.182f, 443.501f, 298.818f, 443.501f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(241.405f, 232.94f)
                    lineTo(203.118f, 232.94f)
                    lineTo(203.118f, 275.005f)
                    lineTo(241.405f, 275.005f)
                    lineTo(241.405f, 232.94f)
                    lineTo(241.405f, 232.94f)
                    lineTo(241.405f, 232.94f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(241.405f, 317.068f)
                    lineTo(279.693f, 317.068f)
                    lineTo(279.693f, 275.005f)
                    lineTo(241.405f, 275.005f)
                    lineTo(241.405f, 317.068f)
                    lineTo(241.405f, 317.068f)
                    lineTo(241.405f, 317.068f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(203.118f, 347.84f)
                    curveTo(203.118f, 351.66f, 203.356f, 355.428f, 203.796f, 359.133f)
                    lineTo(241.405f, 359.133f)
                    lineTo(241.405f, 317.068f)
                    lineTo(203.118f, 317.068f)
                    lineTo(203.118f, 347.84f)
                    lineTo(203.118f, 347.84f)
                    lineTo(203.118f, 347.84f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(317.98f, 317.068f)
                    lineTo(279.693f, 317.068f)
                    lineTo(279.693f, 359.133f)
                    lineTo(317.98f, 359.133f)
                    lineTo(317.98f, 317.068f)
                    lineTo(317.98f, 317.068f)
                    lineTo(317.98f, 317.068f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(317.98f, 401.196f)
                    lineTo(356.268f, 401.196f)
                    lineTo(356.268f, 359.133f)
                    lineTo(317.98f, 359.133f)
                    lineTo(317.98f, 401.196f)
                    lineTo(317.98f, 401.196f)
                    lineTo(317.98f, 401.196f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(356.268f, 424.207f)
                    curveTo(364.757f, 417.799f, 372.156f, 410.017f, 378.126f, 401.199f)
                    lineTo(356.268f, 401.199f)
                    lineTo(356.268f, 424.207f)
                    lineTo(356.268f, 424.207f)
                    lineTo(356.268f, 424.207f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(241.406f, 401.196f)
                    lineTo(279.694f, 401.196f)
                    lineTo(279.694f, 359.133f)
                    lineTo(241.406f, 359.133f)
                    lineTo(241.406f, 401.196f)
                    lineTo(241.406f, 401.196f)
                    lineTo(241.406f, 401.196f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(219.512f, 401.196f)
                    curveTo(225.489f, 410.027f, 232.902f, 417.819f, 241.406f, 424.233f)
                    lineTo(241.406f, 401.196f)
                    lineTo(219.512f, 401.196f)
                    lineTo(219.512f, 401.196f)
                    lineTo(219.512f, 401.196f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(305.505f, 443.261f)
                    curveTo(309.741f, 442.965f, 313.906f, 442.392f, 317.978f, 441.559f)
                    lineTo(317.978f, 401.196f)
                    lineTo(279.693f, 401.196f)
                    lineTo(279.693f, 441.565f)
                    curveTo(283.752f, 442.396f, 287.906f, 442.965f, 292.129f, 443.257f)
                    curveTo(296.589f, 443.535f, 301.045f, 443.519f, 305.501f, 443.257f)
                    lineTo(305.505f, 443.261f)
                    lineTo(305.505f, 443.261f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(393.838f, 359.133f)
                    curveTo(394.281f, 355.413f, 394.518f, 351.633f, 394.518f, 347.799f)
                    lineTo(394.518f, 317.071f)
                    lineTo(356.264f, 317.071f)
                    lineTo(356.264f, 359.136f)
                    lineTo(393.838f, 359.136f)
                    lineTo(393.838f, 359.133f)
                    lineTo(393.838f, 359.133f)
                    lineTo(393.838f, 359.133f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(317.98f, 317.068f)
                    lineTo(356.268f, 317.068f)
                    lineTo(356.268f, 275.005f)
                    lineTo(317.98f, 275.005f)
                    lineTo(317.98f, 317.068f)
                    lineTo(317.98f, 317.068f)
                    lineTo(317.98f, 317.068f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(317.98f, 232.94f)
                    lineTo(279.694f, 232.94f)
                    lineTo(279.694f, 275.005f)
                    lineTo(317.98f, 275.005f)
                    lineTo(317.98f, 232.94f)
                    lineTo(317.98f, 232.94f)
                    lineTo(317.98f, 232.94f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFED1F24)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(394.518f, 275.005f)
                    lineTo(394.518f, 232.94f)
                    lineTo(356.268f, 232.94f)
                    lineTo(356.268f, 275.005f)
                    lineTo(394.518f, 275.005f)
                    lineTo(394.518f, 275.005f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF4691D4)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(323.441f, 148.392f)
                    lineTo(323.382f, 148.427f)
                    lineTo(298.87f, 128.352f)
                    lineTo(274.409f, 148.385f)
                    lineTo(279.014f, 203.916f)
                    curveTo(285.564f, 203.376f, 292.184f, 203.087f, 298.87f, 203.087f)
                    curveTo(305.586f, 203.087f, 312.236f, 203.377f, 318.816f, 203.924f)
                    lineTo(323.437f, 148.392f)
                    lineTo(323.441f, 148.392f)
                    lineTo(323.441f, 148.392f)
                    lineTo(323.441f, 148.392f)
                    close()
                }
            }
        }
        .build()
        return _flagHr!!
    }

private var _flagHr: ImageVector? = null
